import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

// Extend the global Window interface so TypeScript doesn't throw errors
declare global {
  interface Window {
    Genesys?: any;
    GenesysJS?: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class GenesysAuthService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  // initializes a listener to wait for genesys chat to exist
  public init(): void {
    // SSR Check: Ensure this only runs in the browser, not during server-side rendering
    if (!isPlatformBrowser(this.platformId)) return;

    if (window.Genesys) {
      this.registerAuthProvider();
    } else {
      // Use the GenesysJS queue hook to catch it the moment it loads
      window.GenesysJS = (queue: () => void) => {
        queue();
        this.registerAuthProvider();
      };
    }
  }

  // Registers the command that hands the Okta token to Genesys
  private registerAuthProvider(): void {
    if (!window.Genesys) return;

    window.Genesys('registerCommand', 'AuthProvider.getAuthCode', (e: any) => {
      try {
        // get storage
        const oktaStorageRaw = localStorage.getItem('okta-token-storage');

        if (!oktaStorageRaw) {
          // no one logged in
          e.reject('No active Okta session.');
          return;
        }

        const oktaStorage = JSON.parse(oktaStorageRaw);
        const tokenToPass = oktaStorage?.accessToken?.accessToken;

        if (tokenToPass) {
          e.resolve({
            authCode: tokenToPass,
            redirectUri: window.location.origin,
          });
        } else {
          e.reject('Okta access token missing.');
        }
      } catch (error) {
        e.reject('Failed to parse Okta storage token.');
      }
    });
  }

  /**
   * Trigger this from your global Angular logout flow
   */
  public logoutOfGenesys(): void {
    if (isPlatformBrowser(this.platformId) && window.Genesys) {
      window.Genesys('command', 'AuthProvider.logout');
    }
  }
}
